module.exports = __webpack_public_path__ + "img/lens-product-orb.5c6aa44e.png";